import { useEsigningRecipients } from 'app/domains/esigning/hooks/useEsigningRecipients';
import { useEsigningSettings } from 'app/domains/esigning/hooks/useEsigningSettings';
import { OrderedSignerRecipients } from './OrderedSignerRecipients';
import { UnorderedSignerRecipients } from './UnorderedSignerRecipients';
export function PendingSignerRecipients() {
    const { signerRecipients } = useEsigningRecipients();
    const { requireOrder } = useEsigningSettings();
    if (requireOrder) {
        return <OrderedSignerRecipients recipients={signerRecipients}/>;
    }
    return <UnorderedSignerRecipients recipients={signerRecipients}/>;
}
